//ES6 import
import simpleParallax from 'simple-parallax-js';
import Glide from "@glidejs/glide/entry/entry-complete";
import { Luminous, LuminousGallery } from 'luminous-lightbox';

const image = document.getElementsByClassName('parallaxContainer');
new simpleParallax(image);


const $toggleMenu = document.querySelector('.nav--toggle') ?? ''
const $closeMenu = document.querySelector('.close-menu') ?? ''
const $menu = document.querySelector('.nav--menu') ?? ''

$toggleMenu.addEventListener('click', function (event) {
    $menu.style.display = 'flex'
}, false);

$closeMenu.addEventListener('click', function (event) {
    $menu.style.display = 'none'
}, false);


/*
* GLIDE
* */
const $glide = document.querySelector('.glide')
if (typeof ($glide) != 'undefined' && $glide != null) {
    let glide = new Glide('.glide', {
        type: 'carousel',
        perView: 3,
        gap: 30,
        focusAt: 'center',
        breakpoints: {
            800: {
                perView: 2
            },
            480: {
                perView: 1
            }
        },
        controls: true
    })

    glide.mount()
}
/*
* END glide
* */

/*
* Smoothly scroll to location
*
* */
const $id = document.querySelector('#toMain')
if (typeof ($id) != 'undefined' && $id != null) {
    const $target = document.querySelector('.pageAnchor').getBoundingClientRect();
    const $navHeight = document.getElementById('nav-main').offsetHeight;

    $id.addEventListener('click', () => {
        let offset = $target.top - $navHeight
        console.log($target)
        console.log($navHeight)
        console.log(offset)
        scrollToSmoothly(offset - 90, 500);
    })

    function scrollToSmoothly(pos, time) {
        /*Time is exact amount of time the scrolling will take (in milliseconds)*/
        /*Pos is the y-position to scroll to (in pixels)*/
        /*Code written by hev1*/
        if (typeof pos !== "number") {
            pos = parseFloat(pos);
        }
        time = time || 500;
        if (typeof time !== "number") {
            time = parseFloat(time);
        }
        if (isNaN(pos)) {
            console.warn("Position must be a number or a numeric String.");
            throw "Position must be a number";
        }
        if (isNaN(time)) {
            console.warn("Time must be a number or a numeric Sting.");
            throw "Time must be a number";
        }
        if (pos < 0 || time < 0) {
            return;
        }
        let currentPos = window.scrollY || window.screenTop;
        let start = null;
        let requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        requestAnimationFrame(function step(currentTime) {
            start = !start ? currentTime : start;
            let progress = currentTime - start;
            if (currentPos < pos) {
                window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
                if (progress < time) {
                    requestAnimationFrame(step);
                } else {
                    window.scrollTo(0, pos);
                }
            } else {
                window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
                if (progress < time) {
                    requestAnimationFrame(step);
                } else {
                    window.scrollTo(0, pos);
                }
            }
        });
    }
}

/*
* END Smooth Scroll
* */
const $lightBox = document.querySelector('.lightBox')
if (typeof ($lightBox) != 'undefined' && $lightBox != null) {
    let options = {
        injectBaseStyles: false,
        showCloseButton: true,
        includeImgixJSClass: true,
    };

    new LuminousGallery(document.querySelectorAll(".imagesGallery a"), options);
}